import type { SVGProps } from 'react'

export const DatabaseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <ellipse cx="8" cy="3.5" rx="6" ry="2" stroke="currentColor" strokeWidth="1.2" />
    <path d="M2 3.5V8C2 9.105 4.686 10 8 10C11.314 10 14 9.105 14 8V3.5" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M2 8V12.5C2 13.605 4.686 14.5 8 14.5C11.314 14.5 14 13.605 14 12.5V8"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
)
